// The 2019-era "framed print on a white wall" photos (plant, stool, side
// table) that sit in many products' DatoCMS image galleries. Every print
// now has a to-scale room image instead, so these are hidden from print
// pages, Google's product data and the Shopping feed. They stay in DatoCMS;
// remove a file name here to bring one back.
//
// Matched by the upload's file name (the last part of its DatoCMS URL).
const OLD_MOCKUPS = new Set([
    "1574880132-addis-ababa-agriculture.jpg", "1589755493-a-frame.jpg",
    "1574887579-adriatic-tankers-2.jpg", "1574887550-akimiski-island-2.jpg",
    "1574887747-amsterdam.jpg", "1574887526-ansan-industrial-sector.jpg",
    "1605830209-framed.jpg", "1574880073-antofagasta-2.jpg",
    "1574887497-arc-de-triomphe-2.jpg", "1574886898-niger-uranium-mine.jpg",
    "1574886765-aspen-snowmass.jpg", "1574886648-austrian-fields.jpg",
    "1574886562-bahamas-clouds.jpg", "1574886224-baltic-algae-bloom-2.jpg",
    "1574886027-boca-raton-2.jpg", "1574885967-boeing-airplane-factory.jpg",
    "1574885716-bolivian-deforestation-2.jpg", "1588895077-bora-bora-copy.jpg",
    "1574885436-brasilia.jpg", "1588888738-ba-frame.jpg",
    "1574885266-california-wildflower-superbloom-2.jpg", "1574885198-calipatria.jpg",
    "1574885122-canola-flowers.jpg", "1574880288-cape-cod-2.jpg",
    "1574885068-central-park-2.jpg", "1600737668-chicago-2.jpg",
    "1574883148-chicago-polar-vortex.jpg", "1574883017-chilean-coast-2.jpg",
    "1574882936-chinese-rice-paddies.jpg", "1588887238-crater-lake.jpg",
    "1574882770-crescent-dunes-solar.jpg", "1574882817-dallas-fort-worth-airport.jpg",
    "1574882671-delray-beach.jpg", "1588888339-dv-frame.jpg",
    "1574882629-dutch-tulips.jpg", "1574882580-eixample-barcelona-jpg.jpg",
    "1579629964-empty-quarter.jpg", "1574882243-everglades.jpg",
    "1574881996-fucino-plain.jpg", "1574881844-golden-gate-bridge.jpg",
    "1574887823-golden-gate-park-2.jpg", "1600737581-gbh-2.jpg",
    "1621878400-24x30-copy.jpg", "1574881804-halong-bay.jpg",
    "1574881718-hawaii-coast.jpg", "1574881684-icelandic-glacial-melt-2.jpg",
    "1574881652-indonesian-ships.jpg", "1574881627-inman-yard.jpg",
    "1574881573-ipanema-beach.jpg", "1591026013-istanbul-2.jpg",
    "1574881541-jacksonville-turbine-interchange.jpg", "1574881509-jwaneng-diamond-mine.jpg",
    "1574881480-kansas-pivot-irrigation.jpg", "1575483063-kansas-pivot-irrigation-2-copy.jpg",
    "1574880313-lax.jpg", "1574881246-lake-mead.jpg",
    "1574710311-natron-low-res.jpeg", "1574881216-lithium-solar-ponds.jpg",
    "1574881442-london-2.jpg", "1574881599-lop-nur-potash-evaporation-ponds-2.jpg",
    "1574887852-luoyan-bay-aquaculture.jpg", "1574881771-malaysian-palms.jpg",
    "1579629998-manhattan.jpg", "1574881931-michigan-tailings-pond.jpg",
    "1574880410-moab-potash-ponds.jpg", "1574882141-mont-st-michel.jpg",
    "1574882284-morocco-solar-2.jpg", "1574882325-mount-fuji.jpg",
    "1574882404-mount-whaleback-iron-ore-mine.jpg", "1600791055-nsh.jpg",
    "1574882490-new-hamshpire-fall-foliage.jpg", "1574880371-new-york-city-low-angle.jpg",
    "1574882733-nezahualcoyotl.jpg", "1574882855-niagara-falls.jpg",
    "1579629823-nice.jpg", "1574882964-olive-trees.jpg",
    "1574883076-palmanova.jpg", "1574883109-paris.jpg",
    "1574884966-pembrokeshire-wales-2.jpg", "1579629739-perito-moreno.jpg",
    "1574885158-perth-waves.jpg", "1579629870-piraeus.jpg",
    "1574886324-no-3-port-newark.jpg", "1574885375-port-of-rotterdam.jpg",
    "1600737630-pg-2.jpg", "1574885478-reganne-rock-2.jpg",
    "1579630055-reservoir-houseboats.jpg", "1579629780-riyhadh.jpg",
    "1574886004-san-francisco-bay-salt-ponds.jpg", "1574880346-san-francisco-low-angle.jpg",
    "1588887964-santiago-frame.jpg", "1588887491-santorini-frame.jpg",
    "1574886065-seoul-2.jpg", "1574886495-seville-solar-concentrator.jpg",
    "1574886533-shadegan-lagoon-2.jpg", "1574886616-singapore-tankers.jpg",
    "1574886729-sossusvlei-2.jpg", "1574886939-southern-california-airplane-boneyard.jpg",
    "1574886982-spain-greenhouses.jpg", "1574887067-spiral-jetty.jpg",
    "1574887106-stelvio-pass.jpg", "1574887186-sundarbans-2.jpg",
    "1574887225-sunset-district-san-francisco-2.jpg", "1574887290-sydney-2.jpg",
    "1574887326-sydney-opera-house-2.jpg", "1600737526-sdp2.jpg",
    "1574887369-tagebau-hambach-surface-mine.jpg", "1600790523-tw.jpg",
    "1574887407-tel-aviv.jpg", "1574887436-uae-desert-2.jpg",
    "1574887467-valparaiso.jpg", "1592943907-venice-frame.jpg",
    "1574887637-wadi-rum-2.jpg", "1574880158-yakutia-2.jpg",
]);

const fileName = (url) => String(url || "").split("?")[0].split("/").pop();

const isOldMockup = (img) => OLD_MOCKUPS.has(fileName(img && img.url));

// A product's gallery without the old mockups. Never returns an empty list:
// if every image were a mockup, the original gallery is kept.
const withoutOldMockups = (images) => {
    const list = images || [];
    const kept = list.filter((img) => !isOldMockup(img));
    return kept.length ? kept : list;
};

module.exports = { OLD_MOCKUPS, isOldMockup, withoutOldMockups };
